import { render, staticRenderFns } from "./WebFrame.vue?vue&type=template&id=7f94a8f6"
import script from "./WebFrame.vue?vue&type=script&lang=js"
export * from "./WebFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports